import styled from "styled-components"

const NavItem = styled.li`
  &:active {
    & div > span {
      & > span::before {
        content: "// ";
        color: ${(props) => props.theme.a_color_gradients.c_dark};
        background-color: transparent !important;
        font-weight: 700;
      }
    }
  }

  &:hover {
    & > div span {
      & > span::before {
        content: "// ";
        color: ${(props) => props.theme.a_color_gradients.a_dark};
        background-color: transparent !important;
        font-weight: 700;
      }
    }
  }
`
const SubItemContainer = styled.div`
  & > a {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  @media (max-width: 899px) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const SubItemContainerListItem = styled.li`
  & > a {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  @media (max-width: 899px) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const SubItem = styled.span`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const SubNavItemTitle = styled.li`
  & > a {
    border-bottom: 1px solid
      ${(props) => props.theme.c_color_gradients.c_medium};
  }
`
const MainNav = styled.nav`
  @media (max-width: 899px) {
    border-top: 4px solid ${(props) => props.theme.a_color_gradients.a_dark};
    & > ul {
      &>li: hover, &>li:focus-within { {
        background-color: ${(props) => props.theme.a_color_gradients.a_dark};
      }
      & > li {
        border-bottom: 2px solid
          ${(props) => props.theme.a_color_gradients.a_light};
      }
    }
  }
`

export {
  NavItem,
  SubItemContainer,
  SubItem,
  SubNavItemTitle,
  MainNav,
  SubItemContainerListItem,
}
